import moment from 'moment';
export const getTimelineData = (boardTimeline: any, boardDetails: any) => {
    const boardJson = JSON.stringify(boardTimeline);
    const boardJsonObj = JSON.parse(boardJson);
    let tasks = [];
    if (
      typeof boardJsonObj.tasks !== "undefined" &&
      boardJsonObj.tasks.length
    ) {
      tasks = JSON.parse(JSON.stringify(boardJsonObj.tasks));
    }
    const { tagId, boardType } = boardDetails;
    let timelineStart = boardJsonObj.start_date || null;
    let timelineEnd = boardJsonObj.end_date || null;
    const filteredTasks = tasks.filter((item: any) => {
      if (Array.isArray(item.data)) {
        item.data = item.data.filter((item1: any) => {
          if (
            typeof item1.start === "undefined" ||
            item1.start == "0" ||
            item1.start == "" ||
            item1.start == null ||
            (typeof item1.end === "undefined" ||
              item1.end == "0" ||
              item1.end == "" ||
              item1.end == null)
          ) {
            return false;
          }
          if (boardType == "2") {
            let findAi = undefined;
            for(let s of boardDetails.columns) {
                findAi = s.data && s.data.find((d: any) => d.id == item1.id && d.board_column > 0);
                if (findAi) {
                    break;
                }
            }
            if (!findAi) {
              return false;
            }
          }
          if (item1.wsId == tagId) {
            if (!timelineStart || item1.start < timelineStart) {
              timelineStart = item1.start;
            }
            if (!timelineEnd || item1.end > timelineEnd) {
              timelineEnd = item1.end;
            }
          }
          return item1;
        });
        return item.data.length && item.data.find((item: any) => item.wsId == tagId);
      }
      return false;
    });
    const reducedTasks = filteredTasks.reduce((result: any, t: any) => {
      if (Array.isArray(t.data)) {
        t.data = t.data.filter((fd: any) => {
          const diff = moment(fd.start * 1000).diff(
            timelineStart * 1000,
            "days"
          );
          return !(diff > 365);
        });
        if (t.data.length) {
          result = result.concat(t);
        }
      }
      return result;
    }, []);
    return {
        filteredTasks,
        reducedTasks
    }
}

export const getTimelineConfig = (boardTimeline: any, boardDetails: any) => {
    const boardObj = JSON.parse(JSON.stringify(boardTimeline));
    const { is_manager, is_co_manager, is_team_admin,
        boardType, tagId, user } = boardDetails;
    let view_mode = 'Week';
    let ganttTimescale = document.querySelector('#gantt-timescale');
    if (ganttTimescale) {
        const timescaleMode = ganttTimescale.getAttribute('data-value');
        if (timescaleMode !== 'undefined') {
            view_mode = timescaleMode.charAt(0).toUpperCase() + timescaleMode.substr(1).toLowerCase();
        }
    }
    let sortingId = 'asc';
    let ganttSorting = document.querySelector('#gantt-sorting');
    if (ganttSorting) {
        const sortingView = ganttSorting.getAttribute('data-value');
        if (sortingView !== 'undefined') {
            sortingId = sortingView;
        }
    }
    const config: any = {
        svg_class: 'wb-board-timeline-svg',
        task_list_width: 1,
        bar: {
          height: 10,
          corner_radius: 2.5,
          class: 'wsBoardAiFullDet',
        },
        padding: 30,
        header_height: 50,
        shadecolor: '#0FAFC2',
        overlapping_colors: ['#0FAFC2', '#00ACC1', '#0097A7', '#00838F'],
        overlapping_days: 30,
        gantt_start: boardObj.start_date || null,
        gantt_end: boardObj.end_date || null,
        wsId: boardObj.wsId || null,
        current_user_id: user.id || null,
        is_manager: is_manager || false,
        is_co_manager: is_co_manager || false,
        is_team_admin: is_team_admin || false,
        render_task_list: 'ws-task-name-wrapper',
        focus_today: true,
        offset: boardDetails.currentDate.offset || 0,
        timeline_type: 'board',
        maximum_year: false,
        view_mode,
        sorting: {
          enabled: true,
          id: sortingId,
        },
      };
    return config;
}

export const afterGridRenderView = () => {
  let chartWidth = $(window).width() - 40;
  const keepopen = $('#leftmenu_navigation')
    .find('.leftmenu-wrapper')
    .attr('data-keepopen');
  if (keepopen === 'true') {
      chartWidth -= 275; // width of opened left menu
  }
  if (keepopen === 'false') {
      chartWidth -= 40; // width of closed left menu
  }
  chartWidth -= 151; // width of legend
  $('.gantt-chart-wrapper').width(chartWidth);
}

const createTask = (task: any, tagId: any) => ({
  id: task.id,
  name: task.description,
  owner: task.owner,
  start: task.start_date,
  end: task.due_date,
  parent: task.parent,
  progress: 100,
  wsId: tagId,
  teamId: task.teamId,
  type: task.type
});

export const updateTimleineTask = (board: any, item: any, oldOwner?: any) => {
  const {boardDetails, boardTimeline} = board;
  const {tagId} = boardDetails;
  let {tasks=[], users=[]}: any = boardTimeline;
  const findUser = tasks.find((it: any) => it.id == item.owner);
  console.log('updateTimleineTask', item);
  if (oldOwner && oldOwner > 0) {
    tasks = tasks.map((task: any) => {
      if (task.id == oldOwner) {
        task.data = task.data.filter((r: any) => r.id != item.id);
      }
      return task;
    });
  }
  if (findUser) {
    tasks = tasks.map((task: any) => {
      if (task.id == item.owner) {
        const task_data = createTask(item, tagId);
        const findTask = task.data.find((f: any) => f.id == item.id);
        if (findTask) {
          task.data = task.data.map((d: any) => {
            if (d.id == item.id) {
              d = Object.assign({}, d, task_data);
            }
            return d;
          });
        } else {
          console.log('new', task_data);
          task.data.push(task_data);
        }
      }
      return task;
    });
  } else {
    // console.log('new user data');
    // console.log(item);
    const newUserData: any = {
      id: item.owner,
      name: `${item.owner_firstname} ${item.owner_lastname}`,
      data: [],
    };
    newUserData.data.push(createTask(item, tagId));
    const _findUser = users.find((user: any) => user.id == newUserData.id);
    if (!_findUser) {
      users.push({ id: newUserData.id, name: newUserData.name });
    }
    // console.log(newUserData);
    tasks.push(newUserData);
  }
  tasks = tasks.filter((i: any) => i.data && i.data.length
            && i.data.find((item1: any) => item1.wsId == tagId));
  
  return {...boardTimeline, tasks, users};
}

export const removeTimelineTask = (board: any, taskId: any) => {
  const {boardDetails, boardTimeline} = board;
  const {tagId} = boardDetails;
  let {tasks=[]}: any = boardTimeline;
  tasks = tasks.map((task: any) => {
    task.data = task.data.filter((item: any) => (
      (Array.isArray(taskId)) ? !taskId.includes(item.id) : (item.id != taskId)
    ));
    return task;
  });
  tasks = tasks.filter((item: any) => item.data && item.data.length
            && item.data.find((item1: any) => item1.wsId == tagId));

  return {...boardTimeline, tasks};
}
